import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import SEO from '@/components/SEO';

const TermsPage = () => (
  <div className="min-h-screen bg-white">
    <SEO
      title="Terms of Service | Paisley Scotland"
      description="The terms and conditions governing your use of paisleyscotland.com and the services we provide."
      url="https://paisleyscotland.com/terms"
    />
    <Navbar />
    <article className="pt-28 pb-20" data-testid="terms-page">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 prose prose-slate prose-lg">
        <h1 className="font-heading">Terms of Service</h1>
        <p className="text-sm text-slate-500">Last updated: {new Date().toLocaleDateString('en-GB')}</p>

        <p>
          These Terms of Service govern your use of paisleyscotland.com
          (the “Service”) operated by Paisley Scotland. By accessing or using the
          Service you agree to be bound by these Terms.
        </p>

        <h2>1. Use of the Service</h2>
        <p>
          You agree to use the Service only for lawful purposes and in a way that
          does not infringe the rights of, restrict or inhibit anyone else's use
          and enjoyment of it.
        </p>

        <h2>2. Sponsorship & Listings</h2>
        <ul>
          <li>All sponsorship purchases are processed securely via Stripe.</li>
          <li>Listings, content and logos provided by sponsors must be accurate, lawful and not infringe any third-party rights.</li>
          <li>We reserve the right to refuse, suspend or remove any listing that breaches these terms or applicable law.</li>
        </ul>

        <h2>3. Payments & Refunds</h2>
        <p>
          Sponsorship packages and event-spotlight promotions are payable in
          advance. Refunds are considered on a case-by-case basis within 14 days
          of purchase for services that have not yet gone live. Contact
          <a href="mailto:brian@paisley.org.uk"> brian@paisley.org.uk</a> to request a refund.
        </p>

        <h2>4. Content & Intellectual Property</h2>
        <p>
          All site content (excluding sponsor-supplied materials) is the property
          of Paisley Scotland and is protected by UK copyright law. You may not
          reproduce, distribute or create derivative works without our written
          permission.
        </p>

        <h2>5. Third-Party Links</h2>
        <p>
          The Service may contain links to third-party websites that are not
          owned or controlled by Paisley Scotland. We have no responsibility for
          the content, privacy policies or practices of any third-party sites.
        </p>

        <h2>6. Disclaimer of Warranties</h2>
        <p>
          The Service is provided on an "as is" and "as available" basis. We make
          no warranty that the Service will be uninterrupted, error-free, or free
          from viruses or other harmful components.
        </p>

        <h2>7. Limitation of Liability</h2>
        <p>
          To the maximum extent permitted by law, Paisley Scotland shall not be
          liable for any indirect, incidental, special or consequential damages
          arising from your use of the Service.
        </p>

        <h2>8. Changes to These Terms</h2>
        <p>
          We may revise these Terms at any time. Continued use of the Service
          after changes are posted constitutes your acceptance of the revised
          Terms.
        </p>

        <h2>9. Governing Law</h2>
        <p>
          These Terms are governed by the laws of Scotland. Any disputes shall be
          subject to the exclusive jurisdiction of the Scottish courts.
        </p>

        <h2>10. Contact</h2>
        <p>
          Questions about these Terms? Email
          <a href="mailto:brian@paisley.org.uk"> brian@paisley.org.uk</a>.
        </p>
      </div>
    </article>
    <Footer />
  </div>
);

export default TermsPage;
